import { render, staticRenderFns } from "./ExpedienteEntryApertura.vue?vue&type=template&id=93e28310&scoped=true&"
import script from "./ExpedienteEntryApertura.vue?vue&type=script&lang=js&"
export * from "./ExpedienteEntryApertura.vue?vue&type=script&lang=js&"
import style0 from "./ExpedienteEntryApertura.vue?vue&type=style&index=0&id=93e28310&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e28310",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VCardText,
  VDataTable,
  VDivider,
  VFlex,
  VLayout,
  VTextField,
})
